@if (loaded()) {
  <div class="report-container">
    <hyperkit-typography variant="h5">Overview</hyperkit-typography>
    <report-text-block
      title="Executive Summary"
      [value]="huntView.executiveSummary()"
    ></report-text-block>
    <report-text-block
      title="Abstract"
      [value]="huntView.abstract()"
    ></report-text-block>
    <report-text-block
      title="Hypothesis"
      [value]="huntView.hypothesis()"
    ></report-text-block>
  </div>
} @else {
  <p>Loading…</p>
}
